import React from "react";
import EarlyAccess from "../components/app/common/EarlyAccess";
import FindJobLayout from "../components/app/layout/FindJobLayout";
import LeadershipTeam from "../components/app/company/LeadershipTeam";
import ManagementTeam from "../components/app/company/ManagementTeam";
import { BlurFade } from "../components/app/BlurFade";

const CompanyPage: React.FC = () => {
  return (
    <div
      className="w-full"

    >
      <section style={{
        backgroundImage: "url(/home-hero.svg)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }} className="min-h-[70vh] lg:bg-bottom sm:min-h-[100vh] bg-white bg-gradient-to-b flex p-5 lg:px-10 xl:px-16 justify-center items-center pt-[0rem] md:pt-0 ">
        <BlurFade delay={0.25} inView>
          <div className="grid md:grid-cols-3 md:flex-row gap-5 pl-5">
            <div className="flex justify-center col-span-1 items-center">
              <h3 className="text-white text-2xl md:text-3xl transition-all duration-150 ease-out lg:text-5xl w-full max-w-5xl font-light xl:leading-snug xl:pb-12">
                Dream Weavers Leadership
              </h3>
            </div>
            <div className="text-white col-span-2">
              <div className="flex justify-end">
                <h4 className="text-xs sm:text-sm lg:text-lg xl:text-3xl xl:pb-3 font-light">
                  A Message from our CMD
                </h4>
              </div>
              <div className="flex justify-end pt-1">
                {/* replace this with the video */}
                <iframe
                  title="YouTube video player"
                  src="https://www.youtube.com/embed/ijLOuLiJzgY?si=aclijM9ktDpARloX"
                  className="md:max-w-2xl w-96 h-[12rem] sm:h-[19rem] rounded-2xl xl:max-w-[43rem] max-h-[17rem] max-w-[17rem] lg:max-h-[26rem] xl:h-[25rem] xl:w-[45rem] lg:h-[20rem] sm:w-[29rem]"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
                {/* <img
                  alt=""
                  src="/home/our-mission.png"
                  className="transition-all duration-200 ease-out bg-center bg-cover h-[10rem] sm:h-[16rem] md:h-[20rem] lg:h-[27rem]"
                /> */}
              </div>
            </div>
          </div>
        </BlurFade>
      </section>
      <BlurFade delay={0.25} inView className="bg-white -mt-1 lg:-mt-20">
        <section className="p-5 sm:p-7 lg:p-10 xl:px-16 xl:mt-16">
          <LeadershipTeam />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView className="bg-white">
        <section className="p-5 sm:p-7 lg:p-10 xl:px-16 xl:mt-10">
          <ManagementTeam />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="xl:pt-10">
          <FindJobLayout
            title="Our Dreamers make the Difference"
            description="Guided by Values, Driven by Excellence Discover the principles that define who we are and shape everything we do."
            buttonContent="See our portfolio"
            buttonUrl="/aboutus"
            underlineUrl="/careers"
          />
        </section>
      </BlurFade>
      {/* <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-10 xl:px-[4.1rem]">
          <Projects />
        </section>
      </BlurFade> */}
      <section
        className="px-5 sm:px-10"
        style={{
          backgroundImage: "url('/home/early-access-bg.svg')",
        }}
      >
        <EarlyAccess />
      </section>
    </div>
  );
};

export default CompanyPage;
